import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "data-test", "minWidth"];
import React from 'react';
import { Flex } from '../Flex';
export var Menu = function Menu(_ref) {
  var children = _ref.children,
      _ref$dataTest = _ref['data-test'],
      testId = _ref$dataTest === void 0 ? 'menu' : _ref$dataTest,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 220 : _ref$minWidth,
      otherStyleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Flex, _extends({
    flexDirection: "column",
    "data-test": testId,
    minWidth: minWidth
  }, otherStyleProps), children);
};